import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const TextEditor = ({ value, onChange, iseditable = true }) => (
  <ReactQuill
    value={value}
    onChange={onChange}
    modules={TextEditor.modules}
    formats={TextEditor.formats}
    readOnly={!iseditable}
    theme="snow"
  />
);

TextEditor.modules = {
  toolbar: [
    [{ header: 1 }, { header: 2 }],
    ['bold', 'italic', 'underline'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ align: [] }],
  ],
};

TextEditor.formats = ['header', 'bold', 'italic', 'underline', 'list', 'bullet', 'align', 'link', 'image'];

export default TextEditor;
